import styled from '@emotion/styled'
import { Text } from 'theme-ui'

import { WithTheme } from '../../../setup'
import media from '../../../common/MediaQueries'
import { listReset } from '../../../common/Mixins'
import { IconTick } from '../../../assets/svg'
import { IconBoxItemsLeft, IconBoxItemsRight } from '../../../assets/svg'

export const ReasonsWhyStyled = styled.div``

export const ReasonsWhyContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4rem;
  @media ${media.tablet} {
    position: relative;
    margin-top: 6.5rem;
  }
`

export const ReasonsWhyLabelStyled = styled(Text)<WithTheme>`
  position: relative;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-family: 'Montserrat';

  @media ${media.tablet} {
    width: calc(100% - 18.75rem);
    max-width: 9.5rem;
    max-height: 2.25rem;
  }

  @media ${media.desktop} {
    max-width: 17.5rem;
    max-height: 3.125rem;
  }
`

export const ReasonsWhyArrowStyled = styled.div`
  position: absolute;
  @media ${media.maxTablet} {
    display: none;
  }
`

export const ReasonsWhyListStyled = styled.ul`
  ${listReset}
  margin-top: 4.875rem;

  @media ${media.tablet} {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    display: flex;
    flex-wrap: wrap;
    margin: 0.5rem auto 0 auto;
    max-width: 82.75rem;
  }
`

export const ReasonsWhyListItemStyled = styled.li`
  display: flex;

  @media ${media.maxTablet} {
    &:not(:first-child) {
      margin-top: 1.5rem;
    }
  }

  @media ${media.tablet} {
    position: relative;
    width: 50%;

    margin: 2.25rem 0;

    &:nth-child(odd) {
      ${ReasonsWhyArrowStyled} {
        right: -9.125rem;
        top: 0.75rem;
      }
      ${ReasonsWhyLabelStyled} {
        text-align: right;
      }
    }

    &:nth-child(even) {
      display: flex;
      justify-content: flex-end;
      ${ReasonsWhyArrowStyled} {
        left: -9.125rem;
        top: 0.75rem;
      }
      ${ReasonsWhyLabelStyled} {
        text-align: left;
      }
    }

    &:nth-child(3),
    &:nth-child(7) {
      ${ReasonsWhyArrowStyled} {
        right: -9.375rem;
        transform: rotate(-15deg) translateY(-1rem);
      }
    }

    &:nth-child(4),
    &:nth-child(8) {
      ${ReasonsWhyArrowStyled} {
        left: -9.375rem;
        transform: rotate(15deg) translateY(-1rem);
      }
    }
  }
`

export const ReasonsWhyIconStyled = styled(IconTick)`
  margin: 0.5rem 1.25rem 0 0;
  min-width: 1rem;

  @media ${media.tablet} {
    display: none;
  }
`

export const ReasonsWhyActionStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 4rem;
  @media ${media.tablet} {
    margin-top: 6rem;
  }
`

export const ReasonsWhyMediaStyled = styled.div`
  position: relative;
`

export const ReasonsWhyMediaLeftStyled = styled(IconBoxItemsLeft)`
  position: absolute;
  left: -7.5rem;
  top: 4.5rem;
  width: 0.82em;
  font-size: 16rem;

  @media ${media.tablet} {
    font-size: 18.125rem;
    top: 5.75rem;
    left: -8.5rem;
  }
`

export const ReasonsWhyMediaRightStyled = styled(IconBoxItemsRight)`
  position: absolute;
  right: -7.5rem;
  top: 4.5rem;
  width: 0.82em;
  font-size: 16rem;

  @media ${media.tablet} {
    font-size: 18.125rem;
    top: 5.75rem;
    right: -8.5rem;
  }
`

export const ReasonsWhyBoxStyled = styled.div<WithTheme>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 16.5rem;
  background-color: ${({ theme }) => theme.colors.green};
  padding: 3.75rem 0.75rem 1.75rem;
  border-radius: 0.375rem;
  z-index: 2;
  min-height: 25.375rem;

  @media ${media.tablet} {
    min-height: 28.625rem;
    width: 18.75rem;
    padding: 4.25rem 0.75rem 3.375rem;
  }
`

export const ReasonsWhyBoxLabelStyled = styled(Text)<WithTheme>`
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-top: 2.75rem;
`

export const ReasonsWhyBoxInfoStyled = styled(Text)<WithTheme>`
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin-top: 2rem;
  line-height: 1.8;
`
